export default "__VITE_ASSET__D6Rost2B__"